module.exports = __webpack_public_path__ + "media/svg-new/Group 638-a6583cd2.svg";